<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img
        src="/img/white-avatar.png"
        class="img-avatar"
        :alt="userName" />
    </template>
    <template slot="dropdown">
      <b-dropdown-header
        tag="div"
        class="text-center">
        <strong>ข้อมูลอื่น ๆ</strong>
      </b-dropdown-header>
      <b-dropdown-item v-on:click="logout"><i class="fa fa-sign-out" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {
      userName: ''
    }
  },
  mounted () {
  },
  methods: {
    async logout () {
      this.$cookies.remove('token')
      localStorage.clear()
      this.$router.push({ name: 'home' })
    },
    goHowToUse () {
      window.open('https://www.logisty.asia/how-to-use', '_blank')
    },
    goContactUs () {
      this.$router.push({ name: 'ติดต่อเรา' })
    },
    goProfile () {
      this.$router.push({ name: 'ข้อมูลของฉัน' })
    }
  }
}
</script>
